import { createActions } from '../utils/actions';

const { actions: auth } = createActions('auth')
  .addAsync('commitPasswordReset')
  .addAsync('createAccount')
  .addAsync('requestPasswordReset')
  .add('resetPasswordStatus')
  .add('setData')
  .addAsync('signIn');

export default auth;
